<template>
    <div>
        <v-dialog
            v-model="display"
            width="1150"
            scrollable
            persistent>
            <v-card flat>
                <v-toolbar flat dense color="primary" dark class="mb-2">
                    <v-toolbar-title>{{ $t('invoice_display_title') }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <p-icon-btn v-if="invoice && invoice.meta && invoice.meta.postable" color="gray lighten-2" @click="simulate" tooltip="Simulate Entry" icon="mdi-form-select" :loading="loading.simulate"></p-icon-btn>
                    <v-menu
                        offset-y>
                        <template v-slot:activator="{on}">
                            <v-btn
                                icon
                                v-on="on"
                                class="mx-1">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list width="250" dense>
                            <v-list-item
                                :disabled="!(invoice && invoice.meta && invoice.meta.reversable)"
                                @click="handleReverse"
                                link
                                >
                                <v-list-item-icon>
                                    <v-icon>mdi-arrow-u-left-bottom</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("reverse") }}</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                                :disabled="!(invoice && invoice.meta && invoice.meta.postable)"
                                @click="simulate"
                                link>
                                <v-list-item-icon>
                                    <v-icon>mdi-form-select</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t('simulate_entry') }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-alert type="info" dense text v-if="loading.simulate">
                        <span v-html="aicaSimulatingAlert"></span>
                    </v-alert>
                    <v-subheader>{{ $t('title_info') }}</v-subheader>
                    <v-simple-table dense>
                        <tbody>
                            <tr>
                                <th>{{ $t('date') }}</th>
                                <td>{{ invoice.date }}</td>
                                 <th>{{ $t('document_date') }}</th>
                                <td>{{ invoice.date }}</td>
                                <th>{{ $t('code') }}</th>
                                <td>{{ invoice.code }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('customer') }}</th>
                                <td>{{ invoice.customer }}</td>
                                <th>{{ $t('sites_customer') }}</th>
                                <td>{{ invoice.site }}</td>
                                <th>{{ $t('state') }}</th>
                                <td>
                                    <!-- <v-badge dot :color="getColor(invoice.state)" inline left></v-badge>{{ invoice.state }} -->
                                    <p-status v-if="invoice" :state="invoice.state"></p-status>
                                </td>
                            </tr>
                            <tr class="font-weight-bold">
                                <th>{{$t("branch")}}</th>
                                <td colspan="5">
                                    <span v-if="invoice && invoice.branch">
                                        {{invoice.branch.name}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-subheader>{{ $t('invoice_line') }}</v-subheader>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>{{ $t('concrete') }}</th>
                                <th>{{ $t('cast_type') }}</th>
                                <th>{{ $t('quantity') }}</th>
                                <th>{{ $t("unit_measure") }}</th>
                                <th>{{ $t('price') }}</th>
                                <th>{{ $t("sub_total") }}</th>
                                <th>{{ $t("discount") }}</th>
                                <th>{{ $t("tax") }}</th>
                                <th>{{ $t('total') }}</th>
                                <th>{{ $t('sales_order_code') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(invoiceItem, indexInvoice) in invoice.invoice_item_lines" :key="indexInvoice">
                                <td>{{ invoiceItem.item }}</td>
                                <td>{{ invoiceItem.cast_type }}</td>
                                <td>{{ invoiceItem.quantity }}</td>
                                <td>{{ invoiceItem.measure_unit }}</td>
                                <td>{{ formatPrice(invoiceItem.price) }}</td>
                                <td>{{ formatPrice(invoiceItem.subtotal) }}</td>
                                <td>{{ formatPrice(invoiceItem.discount) }}</td>
                                <td>{{ formatPrice(invoiceItem.tax) }}</td>
                                <td>{{ formatPrice(invoiceItem.total) }}</td>
                                <td>{{ invoiceItem.sales_order_code }}</td>
                            </tr>
                            <tr>
                                <th colspan="7"></th>
                                <th>{{ $t('sub_total') }}</th>
                                <td colspan="2"><b>{{ formatPrice(invoice.subtotal) }}</b></td>
                            </tr>
                            <tr>
                                <th colspan="7"></th>
                                <th>{{ $t('discount') }}</th>
                                <td colspan="2"><b>{{ formatPrice(invoice.discount) }}</b></td>
                            </tr>
                            <tr>
                                <th colspan="7"></th>
                                <th>{{ $t('tax') }}</th>
                                <td colspan="2"><b>{{ formatPrice(invoice.tax) }}</b></td>
                            </tr>
                            <tr>
                                <th colspan="7"></th>
                                <th>{{ $t('total') }}</th>
                                <td colspan="2"><b>{{ formatPrice(invoice.total) }}</b></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <br>
                    <v-simple-table dense>
                        <thead>
                            <tr>
                                <th>{{ $t('created_by') }}</th>
                                <th>{{ $t('created_at') }}</th>
                                <th>{{ $t('updated_by') }}</th>
                                <th>{{ $t('updated_at') }}</th>
                                <th>{{ $t('posted_by') }}</th>
                                <th>{{ $t('posted_at') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ invoice.created_by }}</td>
                                <td>{{ moment(invoice.created_at).format("YYYY-MM-DD HH:MM:SS") }}</td>
                                <td>{{ invoice.updated_by }}</td>
                                <td>{{ moment(invoice.updated_at).format("YYYY-MM-DD HH:MM:SS") }}</td>
                                <td>{{ invoice.posted_by }}</td>
                                <td>{{ invoice.posted_at }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="close">
                        {{ $t('close_btn') }}
                    </v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
        <simulate-entries
            v-if="simulateEntryShown"
            v-model="simulateEntryShown"
            :entry="simulatedEntry"
            :is-posted="isPosted"
            :can-post="canPost"
            @post="invoicePost"
            >
        </simulate-entries>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <decision-dialog
            ref="decisionDialog"
            @submit="onSubmitDecision">
        </decision-dialog>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import {formatMoney} from 'accounting';
import moment from 'moment';
import PAlert from '../common/PAlert.vue';


import { getDpk } from '../../services/sales';
import { postInvoiceToLedger, simulateInvoice } from '../../services/sales/invoice';
import { aicaSimulatingAlert } from '../../assets/text/alerts';

import RetryDialog from '@/components/common/RetryDialog';
import SimulateEntries from '../accounting/SimulateEntries.vue';
import getColor from '@/utils/getColor';
import PStatus from '../common/PStatus.vue';
import DecisionDialog from '@/components/common/DecisionDialog'
import invoiceService from "./../../services/sales/invoice";
import PIconBtn from '../common/PIconBtn.vue';

export default {
    name: "InvoiceDisplayDialog",
    components: {
        RetryDialog,
        SimulateEntries,
        PStatus,
        DecisionDialog,
        PIconBtn,
        PAlert
    },
    data() {
        return {
            dpk: null,
            display: false,
            openParams: null,
            loading: {
                data: true,
                simulate: false,
                reverse: false
            },
            simulateEntryShown: false,
            aicaSimulatingAlert,
            simulatedEntry: {},
            alert: {
                display: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
        }
    },
    computed: {
        ...mapState('sales/invoice', ["invoice"]),
        isPosted() {
            return this.invoice.is_posted;
        },
        canPost() {
            return this.invoice.meta.can_post;
        }
    },
    methods: {
        formatPrice(amount) {
            return formatMoney(amount, "SDG ", 2);
        },
        getColor,
        moment,
        ...mapActions("sales/invoice", ["fetchInvoice"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        open(params) {
            this.openParams = params;
            this.loading.data = true;
            this.openDatafetch();
            this.display = true;
        },
        async openDatafetch() {
            try {
                await this.fetchInvoice(this.openParams.id);
                getDpk().then(response => this.dpk = response.data.key);
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"openDataFetch",message});
            }
        },
        simulate() {
            this.loading.simulate = true;
            simulateInvoice({invoiceId: this.invoice.id})
                .then(response => {
                    this.simulatedEntry = response.data;
                    this.simulateEntryShown = true;
                })
                .finally(() => {
                    this.loading.simulate = false;
                });
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close()
            }
        },
        openDecisionDialog() {
            let params = { title: this.$t('confirm_title') , content: this.$t('are_you_sure_posted'), target: 'post'};
            this.$refs.decisionDialog.open(params);
        },
        onSubmitDecision(params) {
            if(params.target == 'post') this.invoicePost();
        },
        async invoicePost() {
            this.loading.data = true;
            postInvoiceToLedger({invoiceId: this.openParams.id, dpk: this.dpk})
                .then(response => {
                    this.setSnackBars({ message: this.$t('msg_post') });
                    this.openDatafetch();
                    this.$emit("updated:invoice", response.data.record);
                })
                .finally(() => {
                    this.loading.data = false;
                })
        },
        close() {
            this.display = false;
        },
        handleReverse() {
            this.alert = {...this.alert, display: true, content: "Are you sure you want to reverse this invoice? This cannot be undone.", callback: this.reverse};
        },
        reverse() {
            this.loading.data = true;
            invoiceService.reverseInvoice(this.openParams.id).then(async () => {
                await this.fetchInvoice(this.openParams.id)
            }).finally(() => {
                this.loading.data = false;
            })
        }
    }
}
</script>